import FirebaseUsage from "../../firebase/firebase.usage";
import {COLLECTIONS} from "../../firebase/constants";
import TaskModel from "../../models/responses/task.model";

export const calculateChangeToTasks = async (
    newProjectId: string,
    newDataVersionId: string,
    oldProjectId: string,
    oldDataVersionId: string,
    allTasks?: Map<string, TaskModel>
) => {
    const newProjectTasks = await FirebaseUsage.getQuery(COLLECTIONS.TASKS,
        ['projectId', '==', newProjectId])
        .then(snapshot => {
            return snapshot.docs.map(doc => doc.data())
        })

    const oldProjectTasks = await FirebaseUsage.getQuery(COLLECTIONS.TASKS,
        ['projectId', '==', oldProjectId])
        .then(snapshot => {
            return snapshot.docs.map(doc => doc.data())
        })

    let newTasksMap = new Map();
    let newTasksByTaskId = new Map();

    newProjectTasks.forEach(task => {
        newTasksMap.set(task.task_code, task)
        newTasksByTaskId.set(task.task_id, task)
    })

    let oldTasksMap = new Map();
    let oldTasksByTaskId = new Map();

    oldProjectTasks.forEach(task => {
        oldTasksMap.set(task.task_code, task)
        oldTasksByTaskId.set(task.task_id, task)
    })

    let newTasks: any = []
    let deletedTasks: any = []
    let taskDurationChanges: any = []
    let taskNameChanges: any = []
    let taskWBSChanges: any = []
    let tasksDelayed: any = []
    let tasksAhead: any = []
    let logicChanges: any = []
    let tasksStarted: any = []
    let tasksCompleted: any = []

    const statusConverter = {
        'not started': 'not started',
        'block': 'not started',
        'in progress': 'in progress',
        'suspended': 'in progress',
        'completed': 'completed',
        'declared complete': 'completed'
    }

    newTasksMap.forEach((task, taskCode) => {
        if (!oldTasksMap.has(taskCode)) {
            newTasks.push(task)
        } else {
            const oldTask = oldTasksMap.get(taskCode)
            if (oldTask.targetDuration !== task.targetDuration) {
                taskDurationChanges.push({taskId: oldTask.task_id, newTaskId: task.task_id, oldDuration: oldTask.targetDuration, newDuration: task.targetDuration})
            }
            if (oldTask.taskName !== task.taskName) {
                taskNameChanges.push({taskId: oldTask.task_id, newTaskId: task.task_id, oldTaskName: oldTask.taskName, newTaskName: task.taskName})
            }
            if (oldTask.wbs !== task.wbs) {
                taskWBSChanges.push({taskId: oldTask.task_id, newTaskId: task.task_id, oldWBS: oldTask.wbsPath, newWBS: task.wbsPath})
            }
            if (statusConverter[oldTask.status] === 'not started' && statusConverter[task.status] === 'in progress') {
                tasksStarted.push(task.task_id)
            }
            if (statusConverter[oldTask.status] !== 'completed' && statusConverter[task.status] === 'completed') {
                tasksCompleted.push(task.task_id)
            }
            if (oldTask.early_finsh_date?.seconds > task.early_finish_date?.seconds) {
                tasksAhead.push(task.task_id)
            }
            if (oldTask.early_finish_date?.seconds < task.early_finish_date?.seconds) {
                tasksDelayed.push(task.task_id)
            }
            const oldTaskRelations = oldTask.relations.map(relation =>
                `${oldTasksByTaskId.get(relation.task_id).task_code}-${oldTasksByTaskId.get(relation.pred_task_id).task_code}-${relation.pred_type}-${relation.lag}`
            )
            const newTaskRelations = task.relations.map(relation =>
                `${newTasksByTaskId.get(relation.task_id).task_code}-${newTasksByTaskId.get(relation.pred_task_id).task_code}`
            )
            for (const link of task.relations) {
                const linkId = `${newTasksByTaskId.get(link.task_id).task_code}-${newTasksByTaskId.get(link.pred_task_id).task_code}-${link.pred_type}-${link.lag}`
                if (!oldTaskRelations.includes(linkId)) {
                    let minorChange = false;
                    oldTask.relations.forEach(oldLink => {
                        if (oldLink.task_id === link.task_id && oldLink.pred_task_id === link.pred_task_id) {
                            if (oldLink.pred_type !== link.pred_type) {
                                logicChanges.push({type: "changed type", taskId: link.task_id, predTaskId: link.pred_task_id, oldType: oldLink.pred_type, newType: link.pred_type})
                                minorChange = true;
                            } else {
                                logicChanges.push({type: "changed lag", taskId: link.task_id, predTaskId: link.pred_task_id, oldLag: oldLink.lag, newLag: link.lag})
                                minorChange = true;
                            }
                            if (!minorChange) {
                                logicChanges.push({type: "added link", taskId: link.task_id, predTaskId: link.pred_task_id, predType: link.pred_type, lag: link.lag})
                            }
                        }
                    })
                }
            }
            for (const link of oldTask.relations) {
                const otherTask = oldTasksByTaskId.get(link.task_id === oldTask.task_id ? link.pred_task_id : link.task_id)
                if (otherTask && newTasksMap.has(otherTask.task_code)) {
                    const linkId = `${oldTasksByTaskId.get(link.task_id).task_code}-${oldTasksByTaskId.get(link.pred_task_id).task_code}`
                    if (!newTaskRelations.includes(linkId)) {
                        logicChanges.push({
                            type: "removed link",
                            taskId: newTasksMap.get(link.task_id === oldTask.task_id ? oldTask.task_code : otherTask.task_code).task_id,
                            predTaskId: newTasksMap.get(link.task_id === oldTask.task_id ? otherTask.task_code : oldTask.task_code).task_id,
                            predType: link.pred_type,
                            lag: link.lag
                        })
                    }
                }
            }
        }
    })

    oldTasksMap.forEach((task, taskCode) => {
        if (!newTasksMap.has(taskCode)) {
            deletedTasks.push(task)
        }
    })
}